import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[ngModel][uppercase], [formControlName][uppercase]'
})
export class UppercaseDirective {
  constructor(
    private elementRef: ElementRef,
    private control: NgControl,
  ) {
  }

  @HostListener('input', ['$event']) onInput($event: KeyboardEvent) {
    const newValue = ($event.target as HTMLInputElement).value.toUpperCase();

    this.control.control.setValue(newValue);
  }
}
